(function() {
	window.i18nTranslate = function(obj, customkey) {
		const key = customkey || window.i18nCurrentBaseKey;

		const base = window.i18n[key];

		if (base && obj in base) {
			return base[obj];
		}

		return obj;
	};

	Vue.filter('translate', window.i18nTranslate);
})();
